import { render, staticRenderFns } from "./AnprEventItem.vue?vue&type=template&id=52361c3c&scoped=true"
import script from "./AnprEventItem.vue?vue&type=script&lang=js"
export * from "./AnprEventItem.vue?vue&type=script&lang=js"
import style0 from "./AnprEventItem.vue?vue&type=style&index=0&id=52361c3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52361c3c",
  null
  
)

export default component.exports